import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Result, Button } from 'antd';
import { hasFeaturePermission } from '../utils/permissions';

/**
 * 기능별 권한 체크 컴포넌트
 */
const PermissionGuard = ({ feature, children, fallback }) => {
    const { user } = useSelector((state) => state.auth);

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const hasAccess = hasFeaturePermission(user, feature);

    if (!hasAccess) {
        if (fallback) {
            return fallback;
        }

        return (
            <Result
                status="403"
                title="403"
                subTitle="죄송합니다. 이 기능에 접근할 권한이 없습니다."
                extra={
                    <Button type="primary" onClick={() => window.history.back()}>
                        돌아가기
                    </Button>
                }
            />
        );
    }

    return children;
};

/**
 * 조건부 렌더링 컴포넌트
 */
export const CanAccess = ({ feature, children, fallback = null }) => {
    const { user } = useSelector((state) => state.auth);

    if (!user) {
        return fallback;
    }

    const hasAccess = hasFeaturePermission(user, feature);

    return hasAccess ? children : fallback;
};

export default PermissionGuard;